import { makeStyles } from '@material-ui/core';

export const historicoContaStyles = makeStyles({
  head: {
    height: 52,
    minHeight: 52,
  },
  headText: {
    marginRight: 16,
    fontWeight: 500,
    fontSize: 15,
  },
  historicoItemContainer: {
    paddingLeft: 0,
    paddingRight: 24,
    paddingBottom: 16,
  },
  viewMore: {
    color: '#53c4e6',
    '&:hover, &:focus': {
      cursor: 'pointer',
    },
  },
});
